<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'lineChart',
    data(){
         return {
             chart:'',
             curArrayIndex:null
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        }
        // colorArr:{
        //     type: Array | Object,
        //     default: function () {
        //         let colr = 
        //         return colr;
        //     }
        // }
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        barOption(){
            let that = this;
            var categories = [{name:'全网'},{name:'微博'},{name:'微信'},{name:'头条'},{name:'网页'}];
            that.dataArray.nodes.forEach((node,index) =>{
                node.itemStyle = null;
                node.value = node.symbolSize;
                node.symbolSize *= 2;
                if(index == 0){
                    node.symbolSize = 30;
                }
                node.label = {
                    show: node.symbolSize >= 20,
                    formatter: function(param){
                        var newParams = param.data.name;
                        if(param.data.attributes.time_class!=undefined || param.data.attributes.time_class!=''){
                            newParams = param.name + "\n" + param.data.attributes.time_class;
                        }
                        return newParams
                    }
                };
                node.category = node.attributes.modularity_class;
                that.dataArray.links.forEach((ele,i) =>{
                    if(ele.target == node.id){
                        ele.time = node.attributes.time_class;
                    }
                });
            });
            var option = {
                legend: {
                    textStyle:{
                       color:'#fff' 
                    },
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {
                //             title: '下载',
                //         }
                //     }
                // },
                tooltip: {
                    show:true,
                    formatter: function(param){
                        $("canvas[data-zr-dom-id='zr_100000']").remove();
                        if(param.value == undefined || that.curArrayIndex == param.dataIndex){
                            return
                        }
                        return that.getParams(param);
                    }
                },
                
                color:["#ed7382","#94e8ab","#ffbf91","#94bafb","#f9fb94"],
                animationDuration: 1500,
                animationEasingUpdate: 'quinticInOut',
                series: [{
                    type: 'graph',
                    layout: 'none',
                    symbolSize:10,
                    data: that.dataArray.nodes,
                    links: that.dataArray.links,
                    categories: categories,
                    roam: true,
                    //focusNodeAdjacency: true,
                    
                    label: {
                        position: 'right',
                        formatter: '{b}'
                    },
                    lineStyle: {
                        color: '#999',
                        curveness: 0.3
                    },
                    
                }]
            };
            return option;
        },
        getParams(param,type){
            let that = this,num = 0;
            let newParams = "<div class='echartTip'><p>关系总览</p><table class='table'><tbody><tr><th>账号名</th><th>时间</th><th>来源</th></tr>"
            that.dataArray.links.forEach((ele,i) =>{
                if(ele.source == param.data.id){
                    newParams += "<tr><td>"+ele.target+"</td><td>"+ele.time+"</td><td>"+ele.source+"</td></tr>";
                    num++;
                }
            });
            if(num == 0){
                newParams = param.name + "<br/>" + param.data.attributes.time_class;
            }
            newParams += "</tbody></table>"
            if(type == 1 && num == 0){
                return ''
            }
            return newParams;
        },
        getPostion(param){
            let that = this;
            let curX = param.event.offsetX;
            let curY = param.event.offsetY;
            let wx = $("#"+that.id).width();
            let wy = $("#"+that.id).height();
            let tipW = $(".toolTip").width();
            let tipH = $(".toolTip").height();
            if((curX+tipW) > (wx-20)){
                curX = param.event.offsetX - tipW - 40
            }else{
                curX = param.event.offsetX + 20;
            }
            if((curY+tipH) > (wy-20)){
                curY = param.event.offsetY - tipH - 40
            }else{
                curY = param.event.offsetY + 20;
            }
            $(".toolTip").css({"left":curX,"top":curY})
        },
        init(){
            let that = this;
            that.$echarts.init(document.getElementById(that.id)).dispose();
            that.chart = that.$echarts.init(document.getElementById(that.id));
            that.chart.setOption(that.barOption());
            window.addEventListener("resize",function(){
                that.chart.resize(); 
            });
            $("#"+that.id).append("<div class='toolTip'></div>");
            that.chart.getZr().on('click', param => {
                $(".toolTip").empty().hide()
            });
            that.chart.on('click',function(param){
                var arrayIndex = param.dataIndex;
                that.curArrayIndex = arrayIndex;
                if (param.dataType == 'node') {
                    let html = that.getParams(param,1);
                    if(html == ''){
                        $(".toolTip").empty().hide()
                        return
                    }
                    $(".toolTip").show().empty().append(html);
                    that.getPostion(param)
                }else{
                    $(".toolTip").empty().hide()
                }
            });
           
            
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/pathChart.vue